import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useDeleteWorkoutBenchmark(): UseMutationResult<
  AxiosResponse<null>,
  AxiosError<ErrorMessage>,
  string
> {
  const queryClient = useQueryClient();

  const deleteWorkoutBenchmark = (benchmarkId: string): Promise<AxiosResponse<null>> => {
    return client.delete(`workout-movements/${benchmarkId}/`);
  };

  return useMutation(deleteWorkoutBenchmark, {
    onSuccess: (_, benchmarkId) => {
      queryClient.invalidateQueries({
        predicate: query => query.queryKey[0] === 'workoutBenchmarks' && query.queryKey[1] !== benchmarkId,
      });
    },
  });
}
